import axios from 'axios'
export default {
  // 获取文件的storeId或者ObjectKey, 判断该如何上传文件
  async getFileInfo(file, isTempFile = false) {
    try {
      const md5 = await this.$getMd5(file.raw || file.origin || file)
      const res = !isTempFile && await this.$api.store.getStoreId(md5)
      if (res && res.length) {
        const storeId = res[0]
        return {
          // 是否秒传
          isSkipUpload: true,
          md5,
          storeId
        }
      } else {
        const resPolicy = await this.$api.store.uploadPolicy({ name: file.name, md5 })
        if (resPolicy) {
          const { host, formParameters, objectKey } = resPolicy
          return {
            isSkipUpload: false,
            md5,
            host,
            formParameters,
            objectKey
          }
        }
      }
    } catch (e) {
      this.$fullLoading.close()
      this.$message.error('系统错误')
      window.console.log('error', e)
      return false
    }
  },
  // 根据objectKey 获取 storeId
  async getStoreIdByKey({ md5, name, objectKey }, isTemp = false) {
    try {
      const params = {
        isTemp,
        md5,
        name,
        objectKey
      }
      const res = await this.$api.store.getStoreIdByKey(params)
      if (res) {
        return res.id
      }
    } catch (e) {
      this.$fullLoading.close()
      return false
    }
  },
  /**
   * MD5=>storeId=>policy=>上传=>获取storeId一体化流程
   * progressCb--function：上传进度更新*/
  async uploadFile(file, isTemp = false, progressCb) {
    try {
      const md5 = file.md5 || await this.$getMd5(file.raw || file.origin || file)
      const res = !isTemp && await this.$api.store.getStoreId(md5)
      if (res && res.length) {
        const storeId = res[0]
        progressCb && progressCb(file, 100)
        return {
          ...file,
          name: file.name,
          md5,
          storeId
        }
      } else {
        const resPolicy = await this.$api.store.uploadPolicy({ name: file.name, md5 })
        if (resPolicy) {
          const { host, formParameters, objectKey } = resPolicy
          const formData = new FormData()
          Object.keys(formParameters).forEach((key) => {
            formData.append(key, formParameters[key])
          })
          formData.append('file', file.raw || file.origin || file)
          await axios.post(host, formData, {
            withCredentials: false,
            onUploadProgress: (progressEvent) => {
              const percentage = (progressEvent.loaded / progressEvent.total * 100 | 0)
              progressCb && progressCb(file, percentage)
            }
          })
          // 根据objectKey获取storeId
          const params = {
            isTemp,
            md5,
            name: file.name,
            objectKey
          }
          const storeObj = await this.$api.store.getStoreIdByKey(params)
          if (storeObj) {
            return {
              ...file,
              name: file.name,
              md5,
              storeId: storeObj.id,
            }
          } else {
            return false
          }
        } else {
          return false
        }
      }
    } catch (e) {
      console.log(e)
      this.$fullLoading.close()
      console.log('error', e)
      return false
    }
  }
}
